import {IntlShape} from 'react-intl';

const orderStatusLabelKeyMap = new Map<string, string>([
  ['Commande en cours de validation', 'ORDER_TRACKING.STATUS.VALIDATION_IN_PROGRESS'],
  ['En attente de vos informations', 'ORDER_TRACKING.STATUS.WAITING_INFO'],
  ['Commande validée', 'ORDER_TRACKING.STATUS.VALIDATED'],
  ['Préparation de la mise en production', 'ORDER_TRACKING.STATUS.PREPARING_PRODUCTION'],
  ['En attente de votre validation', 'ORDER_TRACKING.STATUS.WAITING_VALIDATION'],
  ['En cours de production', 'ORDER_TRACKING.STATUS.PRODUCTION_IN_PROGRESS'],
  ['Livrée', 'ORDER_TRACKING.STATUS.DELIVERED'],
  ['Annulée', 'ORDER_TRACKING.STATUS.CANCELLED'],
  ['En cours', 'ORDER_TRACKING.STATUS.IN_PROGRESS'],
]);

export const getOrderStatusColor = (status: string | null): string => {
  switch (status) {
    case 'Livrée':
      return '#5da170';
    case 'Annulée':
      return '#ababab';
    case 'Commande en cours de validation':
    case 'En attente de vos informations':
    case 'Commande validée':
    case 'Préparation de la mise en production':
    case 'En attente de votre validation':
    case 'En cours de production':
    case 'En cours':
      return '#5b70b0';
    default:
      return '#ababab';
  }
};

export const getOrderStatusLabel = (status: string | null, intl: IntlShape): string => {
  if (!status) {
    return '';
  }
  const messageId = orderStatusLabelKeyMap.get(status);
  return messageId ? intl.formatMessage({id: messageId}) : status;
};
